import { baseApiUrl } from '../../config/env';
import { openCustomURL } from '../../utils/common.utils';
import asyncStoreService from '../async-store.service';

export const getCalendarICS = async (tripId) => {
  const queryParam = `tripId=${tripId}`;
  openCustomURL(`${baseApiUrl}/Itinerary/GetCalendarICS?` + queryParam);
};

export const sendItineraryApi = async (tripId, withoutPrice, emails) => {
  const queryParam = `tripId=${tripId}&WithOrwithout=${withoutPrice}&resendEmailTo=${emails}`;
  const token = await asyncStoreService.getTokenData();

  const res = await fetch(`${baseApiUrl}/Itinerary/GetHtmlString?` + queryParam, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${token?.access_token}`,
    },
    body: '',
  });

  if (!res.ok) {
    throw new Error('error sending itinerary details');
  }

  const resultJson = await res.json();
  return resultJson;
};
